/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export const DetailPageHeader = ({ id, title, summaryLine1, summaryLine2, icon, iconText, objectId, statuses, action, className }) => (
  <div id={id} className={`slds-grid detail-page-header ${className}`} style={{ alignItems: 'center' }}>
    <div className='slds-m-left_medium' style={{ width: '5%', textAlign: 'center' }}>
      <div className='slds-m-bottom_small'>
        {icon}
      </div>
      {iconText &&
        <div className='slds-text-title_caps slds-wrap'>
          {iconText}
        </div>
      }
    </div>
    <div className='slds-col slds-p-top_medium slds-p-left_small slds-p-bottom_medium slds-p-right_medium'>
      <div className='slds-text-heading_medium u-no-margin__b u-font-weight-bold'>
        {title}
      </div>
      {summaryLine1
        ? <div className='slds-col slds-m-top_xx-small slds-text-color_weak' style={{ lineHeight: '1.2em' }}>
            {summaryLine1}
            {summaryLine2 &&
              <React.Fragment>
                <br />
                {summaryLine2}
              </React.Fragment>
            }
          </div>
        : <div className='slds-p-bottom_small'></div> //<div className='slds-m-top_x-large'></div>
      }
    </div>
    {statuses &&
      <div className='slds-border_left slds-p-around_medium'>
        {statuses.map(status =>
          <div className='slds-m-right_x-large slds-grid' key={`detailPageHeader_statuses_${status.title}-${status.value}`}>
            <div className='slds-text-color_weak slds-m-right_small'>{status.title}</div>
            {status.value}
          </div>
        )}
      </div>
    }
    {action &&
      <div className='slds-border_left'>
        {action}
      </div>
    }
  </div>
)

DetailPageHeader.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  summaryLine1: PropTypes.string,
  summaryLine2: PropTypes.string,
  icon: PropTypes.element.isRequired,
  iconText: PropTypes.string,
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
      ])
    })
  ),
  action: PropTypes.element,
  className: PropTypes.string
}

DetailPageHeader.defaultProps = {
  id: 'detailPageHeader',
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/detail-page-header/index.js